import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Admin session lives entirely in an httpOnly cookie set by the backend on
// login (see POST /admin/login) — it is never stored in localStorage or
// read by frontend JS, so it can't be exfiltrated via an XSS payload.
// `withCredentials: true` makes the browser attach that cookie automatically
// on every request to the same-origin backend.
export const adminApiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
